// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h2[data-v-a16457aa]{background-image:linear-gradient(90deg,#07677e,#03333f)}", ""]);
// Exports
module.exports = exports;
